var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100 d-flex flex-column overflow-auto"},[_c('VendorList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }